<template>
  <div v-if="visible" id="tab-sub-bill">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            no="1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1);}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{ $t('SeaExport.CodeSearching') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{ $t('SeaExport.CopyFromTheLastTime') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{ $t('SeaExport.CopyFromOtherBill') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyCargoDescriptionAndMarks')">{{ $t('SeaExport.CopyCargoDescriptionAndMarks') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-show="Boolean(form.uuid)"
            no="2"
            :disabled="btnPrintDisabled"
            type="primary"
            @click="originalPrint"
          >{{ form.releaseType === 1 ? $t('SeaExport.PrintTheOriginalBl') : $t('SeaExport.TelexRelease') }}</el-button>
          <el-button v-show="readonly && Boolean(form.uuid)" v-permission="['button_M/HBL_confirmBL']" no="ConfirmChecking" type="primary" @click="pm.confirmBL()">{{ $t('SeaExport.ConfirmChecking') }}</el-button>
          <el-button v-show="readonly&&form.state==2" no="3" type="primary" @click="pm.onState()">{{ $t('SeaExport.Unlock') }}</el-button>
          <el-button v-show="readonly && Boolean(form.uuid)" v-permission="['button_M/HBL_identification']" no="IdentificationList" type="primary" @click="onIdentificationList">{{ $t('SeaExport.IdentificationList') }}</el-button>
          <el-checkbox
            :value="form.state===2"
            :disabled="true"
            style="margin-left: 10px"
          >{{ $t('SeaExport.Locked') }}</el-checkbox>
          <el-checkbox v-model="form.oversea" no="4" style="margin-left: -20px;" :disabled="readonly">{{ $t('SeaExport.BlBeReleased') }}</el-checkbox>
          <el-checkbox v-model="form.manifestEDI" no="5" style="margin-left: -20px;" :disabled="readonly">{{ $t('SeaExport.ManifestEdi') }}</el-checkbox>
          <el-checkbox v-model="form.printParam1" no="6" style="margin-left: -20px;" :disabled="readonly">Part of</el-checkbox>
          <el-checkbox v-model="form.printParam2" no="7" style="margin-left: -20px;" :disabled="readonly">{{ $t('SeaExport.ClauseOfNoWoodPackingMaterial') }}</el-checkbox>
          <el-checkbox
            v-model="form.printParam3"
            no="8"
            style="margin-left: -20px;"
            :disabled="readonly"
            @change="val=>{pm.chargeContainer()}"
          >{{ $t('SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS') }}</el-checkbox>
        </div>
      </div>
    </div>
    <tab-sub-bill-UICustom-layout :element-blocks="elementBlocks" :disabled="readonly">
      <template v-if="elementDict.shipper.viewable" slot="shipper">
        <el-form-item class="auto-width">
          <template slot="label">
            <line-label :class="elementDict.shipper.isRequire ? 'blue ' : ''" :label="elementDict.shipper.label" />
            <char-count :form="form" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <div style="display: flex">
            <el-input v-model="form.shipperCode" :disabled="!elementDict.shipper.writable" no="9" style="flex: 1;width: 129px" />
            <el-button no="10" :disabled="!elementDict.shipper.writable" type="primary" style="margin-left: 6px" @click="pm.onClear(1)">{{ $t('SeaExport.Reset') }}</el-button>
          </div>
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.shipperLine1"
            :disabled="!elementDict.shipper.writable"
            no="11"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showShipperDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('shipperLine1','shipperLine2',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.shipperLine2"
            :disabled="!elementDict.shipper.writable"
            no="12"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showShipperDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('shipperLine2','shipperLine3',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.shipperLine3"
            :disabled="!elementDict.shipper.writable"
            no="13"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showShipperDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('shipperLine3','shipperLine4',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.shipperLine4"
            :disabled="!elementDict.shipper.writable"
            no="14"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showShipperDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('shipperLine4','shipperLine5',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.shipperLine5"
            :disabled="!elementDict.shipper.writable"
            no="15"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showShipperDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('shipperLine5','shipperLine6',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.shipperLine6"
            :disabled="!elementDict.shipper.writable"
            no="16"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showShipperDialog"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.shipperLine7"
            :disabled="!elementDict.shipper.writable"
            no="160"
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showShipperDialog"
          />
        </el-form-item>
      </template>
      <template v-if="elementDict.consignee.viewable" slot="consignee">
        <el-form-item>
          <template slot="label">
            <line-label :class="elementDict.consignee.isRequire ? 'blue ' : ''" :label="elementDict.consignee.label" />
            <char-count :form="form" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <div style="display: flex">
            <el-input v-model="form.consigneeCode" :disabled="!elementDict.consignee.writable" no="17" style="flex:1" />
            <el-button no="18" :disabled="!elementDict.consignee.writable" type="primary" style="margin-left: 6px;" @click="pm.onClear(2)">{{ $t('SeaExport.Reset') }}</el-button>
          </div>
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.consigneeLine1"
            :disabled="!elementDict.consignee.writable"
            no="19"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showConsigneeDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine1','consigneeLine2',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.consigneeLine2"
            :disabled="!elementDict.consignee.writable"
            no="20"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showConsigneeDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine2','consigneeLine3',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.consigneeLine3"
            :disabled="!elementDict.consignee.writable"
            no="21"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showConsigneeDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine3','consigneeLine4',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.consigneeLine4"
            :disabled="!elementDict.consignee.writable"
            no="22"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showConsigneeDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine4','consigneeLine5',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.consigneeLine5"
            :disabled="!elementDict.consignee.writable"
            no="23"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showConsigneeDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine5','consigneeLine6',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.consigneeLine6"
            :disabled="!elementDict.consignee.writable"
            no="24"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showConsigneeDialog"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.consigneeLine7"
            :disabled="!elementDict.consignee.writable"
            no="240"
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showConsigneeDialog"
          />
        </el-form-item>
      </template>
      <template v-if="elementDict.notify.viewable" slot="notify">
        <el-form-item class="auto-width">
          <template slot="label">
            <line-label :class="elementDict.notify.isRequire ? 'blue ' : ''" :label="elementDict.notify.label" />
            <char-count :form="form" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <div>
            <el-input v-model="form.notifyCode" :disabled="!elementDict.notify.writable" no="25" style="flex: 1" />
            <div style="margin-top: 5px">
              <el-button no="26" :disabled="!elementDict.notify.writable" type="primary" @click="pm.onClear(3)">{{ $t('SeaExport.Reset') }}</el-button>
              <el-button no="27" :disabled="!elementDict.notify.writable" type="primary" style="margin-left: 6px;" @click="pm.onCopy_consignee()">{{ $t('SeaExport.CopyTheConsignee') }}</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.notifyLine1"
            :disabled="!elementDict.notify.writable"
            no="28"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showNotifyDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('notifyLine1','notifyLine2',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.notifyLine2"
            :disabled="!elementDict.notify.writable"
            no="29"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showNotifyDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('notifyLine2','notifyLine3',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.notifyLine3"
            :disabled="!elementDict.notify.writable"
            no="30"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showNotifyDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('notifyLine3','notifyLine4',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.notifyLine4"
            :disabled="!elementDict.notify.writable"
            no="31"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showNotifyDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('notifyLine4','notifyLine5',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.notifyLine5"
            :disabled="!elementDict.notify.writable"
            no="32"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showNotifyDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('notifyLine5','notifyLine6',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.notifyLine6"
            :disabled="!elementDict.notify.writable"
            no="33"

            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showNotifyDialog"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.notifyLine7"
            :disabled="!elementDict.notify.writable"
            no="330"
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @dblclick.native="showNotifyDialog"
          />
        </el-form-item>
      </template>
      <template v-if="elementDict.agentParty.viewable" slot="agentParty">
        <el-form-item class="auto-width">
          <line-label slot="label" :class="elementDict.agentParty.isRequire ? 'blue ' : ''" :label="elementDict.agentParty.label" style="color:#404144" />
          <div style="display: flex">
            <div style="flex: 1;text-align: right">
              <el-button no="34" type="primary" style="margin-left: 6px;" @click="pm.onClear(4)">{{ $t('SeaExport.Reset') }}</el-button>
              <el-dropdown
                no="35"
                style="margin-left: 6px;vertical-align: bottom;"
                :class="readonly || !elementDict.agentParty.writable?'not-click':''"
                split-button
                type="primary"
                @click="commandHandle(command3)"
                @command="p=>{command3=p;commandHandle(command3)}"
              >
                {{ command3 }}
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="$t('SeaExport.CopyMblConsignee')">{{ $t('SeaExport.CopyMblConsignee') }}</el-dropdown-item>
                  <el-dropdown-item :command="$t('SeaExport.CopyNominatedAgentInfo')">{{ $t('SeaExport.CopyNominatedAgentInfo') }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.agentPartyLine1"
            :disabled="!elementDict.agentParty.writable"
            no="36"
            :auto-uppercase="isUppercase"
            @dblclick.native="showAgentPartyDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('agentPartyLine1','agentPartyLine2',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.agentPartyLine2"
            :disabled="!elementDict.agentParty.writable"
            no="37"

            :auto-uppercase="isUppercase"
            @dblclick.native="showAgentPartyDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('agentPartyLine2','agentPartyLine3',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.agentPartyLine3"
            :disabled="!elementDict.agentParty.writable"
            no="38"

            :auto-uppercase="isUppercase"
            @dblclick.native="showAgentPartyDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('agentPartyLine3','agentPartyLine4',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.agentPartyLine4"
            :disabled="!elementDict.agentParty.writable"
            no="39"

            :auto-uppercase="isUppercase"
            @dblclick.native="showAgentPartyDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('agentPartyLine4','agentPartyLine5',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.agentPartyLine5"
            :disabled="!elementDict.agentParty.writable"
            no="40"

            :auto-uppercase="isUppercase"
            @dblclick.native="showAgentPartyDialog"
            @change="CargoDocUtil.sftAddrChangeWrap('agentPartyLine5','agentPartyLine6',maxChars)"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.agentPartyLine6"
            :disabled="!elementDict.agentParty.writable"
            no="41"

            :auto-uppercase="isUppercase"
            @dblclick.native="showAgentPartyDialog"
          />
        </el-form-item>
        <el-form-item class="auto-width">
          <cargo-input
            v-model="form.agentPartyLine7"
            :disabled="!elementDict.agentParty.writable"
            no="410"
            :auto-uppercase="isUppercase"
            @dblclick.native="showAgentPartyDialog"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.quantity.viewable" slot="quantity">
        <line-label slot="label" :class="elementDict.quantity.isRequire ? 'blue' : ''" :label="elementDict.quantity.label" />
        <auto-number-input
          v-model="form.quantity"
          :disabled="!elementDict.quantity.writable"
          no="42"
          :precision="0"
          :min="0"
          @change="hblNbr2Change"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.packing.viewable" slot="packing">
        <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
        <cargo-packing-select
          :default-value="form.packing"
          :disabled="!elementDict.packing.writable"
          placeholder=" "
          style="width:100%;"
          @change="p=>{form.packing=p.value}"
        />
      </el-form-item>
      <el-form-item
        v-if="elementDict.packingName.viewable"
        slot="packingName"
      >
        <line-label slot="label" :class="elementDict.packingName.isRequire ? 'blue' : ''" :label="elementDict.packingName.label" />
        <el-input v-model="form.packingName" :disabled="!elementDict.packingName.writable" />
      </el-form-item>
      <el-form-item v-if="elementDict.insideQuantity.viewable" slot="insideQuantity">
        <line-label slot="label" :class="elementDict.insideQuantity.isRequire ? 'blue' : ''" :label="elementDict.insideQuantity.label" />
        <auto-number-input
          v-model="form.insideQuantity"
          :disabled="!elementDict.insideQuantity.writable"
          :precision="0"
          :min="0"
          @change="hblNbr2Change"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.weight.viewable" slot="weight">
        <line-label slot="label" :class="elementDict.weight.isRequire ? 'blue' : ''" :label="elementDict.weight.label" />
        <div style="display: flex">
          <el-input-number
            v-model="form.weight"
            :disabled="!elementDict.weight.writable"
            :precision="3"
            :controls="false"
            style="flex: 1"
            @change="hblNbr2Change"
          />
          <span>KGS</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cubage.viewable" slot="cubage">
        <line-label slot="label" :class="elementDict.cubage.isRequire ? 'blue' : ''" :label="elementDict.cubage.label" />
        <div style="display: flex">
          <el-input-number
            v-model="form.cubage"
            :disabled="!elementDict.cubage.writable"
            :precision="3"
            :controls="false"
            style="flex:1"
            @change="hblNbr2Change"
          />
          <span>CBM</span>
        </div>
      </el-form-item>
      <template v-if="elementDict.cargoEnglishName.viewable" slot="cargoEnglishName">
        <el-form-item v-show="isEdit && elementDict.cargoEnglishName.writable" class="auto-width">
          <div style="display: flex;justify-content: space-between">
            <el-button
              no="43"
              type="primary"
              style="float:right"
              @click="pm.getMBLInfo('EName')"
            >{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromMbl') }}</el-button>
          </div>
        </el-form-item>
        <el-form-item class="auto-width">
          <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
          <cargo-rich-textarea
            v-model="form.cargoEnglishName"
            :show-count="true"
            no="44"
            :disabled="!isEdit || !elementDict.cargoEnglishName.writable"
            :text-chars="0"
            :warning-count="-1"
            wrap-symbol="r"
            :auto-uppercase="isUppercaseByConfig"
            auto-half-word
            style="height: 110px"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val},isUppercaseByConfig,{autoHalfWord: true,autoUppercase: true})"
          />
        </el-form-item>
      </template>
      <template v-if="elementDict.mark.viewable" slot="mark">
        <el-form-item v-show="isEdit && elementDict.mark.writable" class="auto-width">
          <div style="display: flex;justify-content: space-between">
            <el-button
              no="45"
              type="primary"
              style="float:right;margin-left:5px"
              @click="pm.getMBLInfo('mark')"
            >{{ $t('SeaExport.CopyMarksFromMbl') }}</el-button>
          </div>
        </el-form-item>
        <el-form-item class="auto-width">
          <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
          <cargo-rich-textarea
            v-model="form.mark"
            :show-count="true"
            no="46"
            :text-chars="0"
            :warning-count="-1"
            wrap-symbol="r"
            :auto-uppercase="isUppercaseByConfig"
            auto-half-word
            style="height: 110px"
            :disabled="!isEdit || !elementDict.mark.writable"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},isUppercaseByConfig,{autoHalfWord: true,autoUppercase:true})"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.txtQuantitySum.viewable" slot="txtQuantitySum" class="auto-width">
        <line-label slot="label" :class="elementDict.txtQuantitySum.isRequire ? 'blue' : ''" :label="elementDict.txtQuantitySum.label" />
        <el-input :disabled="true" :value="txtQuantitySum" />
      </el-form-item>
      <el-form-item v-if="elementDict.hblNbr2.viewable" slot="hblNbr2">
        <line-label slot="label" :class="elementDict.hblNbr2.isRequire ? 'blue' : ''" :label="elementDict.hblNbr2.label" />
        <el-input v-model="form.hblNbr2" :disabled="!elementDict.hblNbr2.writable" no="47" @input="hblNbr2Change" />
      </el-form-item>
      <el-form-item v-if="elementDict.serialNo.viewable" slot="serialNo">
        <line-label slot="label" :class="elementDict.serialNo.isRequire ? 'blue' : ''" :label="elementDict.serialNo.label" />
        <el-input v-model="form.serialNo" :disabled="!elementDict.serialNo.writable" no="48" />
      </el-form-item>
      <el-form-item v-if="elementDict.txtFirstVesselVoyage.viewable" slot="txtFirstVesselVoyage">
        <line-label slot="label" :class="elementDict.txtFirstVesselVoyage.isRequire ? 'blue' : ''" :label="elementDict.txtFirstVesselVoyage.label" />
        <el-input :disabled="true" :value="txtFirstVesselVoyage" />
      </el-form-item>
      <el-form-item v-if="elementDict.etd.viewable" slot="etd">
        <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
        <el-input :value="moment(job.etd).format('YYYY-MM-DD')" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.dispatchingPlaceCode.viewable" slot="dispatchingPlaceCode">
        <line-label slot="label" :class="elementDict.dispatchingPlaceCode.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlaceCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Seaport"
          filterable
          :default-value="form.dispatchingPlaceCode||''"
          tag-name="englishName"
          @parentCallBack="p=>{pm.portChange(p, 'dispatchingPlace')}"
        />
        <el-input v-model="form.dispatchingPlace" :disabled="!elementDict.dispatchingPlaceCode.writable" no="49" />
      </el-form-item>
      <el-form-item v-if="elementDict.loadingPortCode.viewable" slot="loadingPortCode">
        <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Seaport"
          filterable
          :default-value="form.loadingPortCode||''"
          tag-name="englishName"
          no="loadingPortCode"
          @parentCallBack="p=>{pm.portChange(p, 'loadingPort')}"
        />
        <el-input v-model="form.loadingPort" :disabled="!elementDict.loadingPortCode.writable" no="50" />
      </el-form-item>
      <el-form-item v-if="elementDict.dischargingPortCode.viewable" slot="dischargingPortCode">
        <line-label slot="label" :class="elementDict.dischargingPortCode.isRequire ? 'blue' : ''" :label="elementDict.dischargingPortCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Seaport"
          filterable
          :default-value="form.dischargingPortCode||''"
          tag-name="englishName"
          no="dischargingPortCode"
          @parentCallBack="p=>{pm.portChange(p, 'dischargingPort')}"
        />
        <el-input v-model="form.dischargingPort" :disabled="!elementDict.dischargingPortCode.writable" no="51" />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPortCode.viewable" slot="destinationPortCode">
        <line-label slot="label" :class="elementDict.destinationPortCode.isRequire ? 'blue' : ''" :label="elementDict.destinationPortCode.label" />
        <cargo-advance-select
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Seaport"
          filterable
          :default-value="form.destinationPortCode||''"
          tag-name="englishName"
          no="destinationPortCode"
          @parentCallBack="p=>{pm.portChange(p, 'destinationPort')}"
        />
        <el-input v-model="form.destinationPort" :disabled="!elementDict.destinationPortCode.writable" no="52" />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationPlace.viewable" slot="destinationPlace">
        <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
        <el-input v-model="form.destinationPlace" :disabled="!elementDict.destinationPlace.writable" no="53" />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTerm.viewable" slot="paymentTerm">
        <line-label slot="label" :class="elementDict.paymentTerm.isRequire ? 'blue' : ''" :label="elementDict.paymentTerm.label" />
        <cargo-advance-select
          no="54"
          :disabled="!elementDict.paymentTerm.writable"
          :select-type="TYPE_NAMES.basic_data_PaymentTerm"
          filterable
          :allow-create="true"
          :default-value="form.paymentTerm"
          style="width:100%;"
          @parentCallBack="p=>{form.paymentTerm = p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentPlaceBL.viewable" slot="paymentPlaceBL">
        <line-label slot="label" :class="elementDict.paymentPlaceBL.isRequire ? 'blue' : ''" :label="elementDict.paymentPlaceBL.label" />
        <el-input :disabled="true" :value="form.paymentPlaceBL" />
      </el-form-item>
      <el-form-item v-if="elementDict.freightTermHBL.viewable" slot="freightTermHBL">
        <line-label slot="label" :class="elementDict.freightTermHBL.isRequire ? 'blue' : ''" :label="elementDict.freightTermHBL.label" />
        <el-input :disabled="true" :value="job.freightTermHBL" />
      </el-form-item>
      <el-form-item v-if="elementDict.blNumber.viewable" slot="blNumber">
        <line-label slot="label" :class="elementDict.blNumber.isRequire ? 'blue' : ''" :label="elementDict.blNumber.label" />
        <el-input :disabled="true" :value="form.blNumber" />
      </el-form-item>
      <el-form-item v-if="elementDict.signPlaceBL.viewable" slot="signPlaceBL">
        <line-label slot="label" :class="elementDict.signPlaceBL.isRequire ? 'blue' : ''" :label="elementDict.signPlaceBL.label" />
        <el-input :disabled="true" :value="form.signPlaceBL" />
      </el-form-item>
      <el-form-item v-if="elementDict.signDateBL.viewable" slot="signDateBL">
        <line-label slot="label" :class="elementDict.signDateBL.isRequire ? 'blue' : ''" :label="elementDict.signDateBL.label" />
        <el-date-picker v-model="form.signDateBL" :disabled="!elementDict.signDateBL.writable" no="55" type="date" value-format="yyyy-MM-dd" style="width: 100%;" />
      </el-form-item>
      <el-form-item v-if="elementDict.remarks.viewable" slot="remarks">
        <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
        <el-input
          v-model="form.remarks"
          :disabled="!elementDict.remarks.writable"
          no="56"
          type="textarea"
          :rows="5"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.BlRemarks'),form.remarks,val=>{form.remarks=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.alsoNotify.viewable" slot="alsoNotify">
        <line-label slot="label" :class="elementDict.alsoNotify.isRequire ? 'blue' : ''" :label="elementDict.alsoNotify.label" />
        <cargo-rich-textarea
          v-model="form.alsoNotify"
          no="57"
          :disabled="readonly || !elementDict.alsoNotify.writable"
          :text-chars="0"
          wrap-symbol="r"
          auto-uppercase
          auto-half-word
          style="height: 110px;"
          @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{form.alsoNotify=val.toUpperCase()},notUppercaseShipperConsigneNotify,{warningCount:45,autoHalfWord: true,autoUppercase:true})"
        />
      </el-form-item>
      <el-form-item v-show="job.typeVirtualHbl===VirtualBillType.NORMAL_VIRTUAL_BILL_TYPE.code" slot="orderBusinessAssociation" label-width="0" class="auto-width">
        <cargo-ag-grid
          no="58"
          :grid-options="bill.gridOptions"
          :column-defs="bill.columnDefs"
          :row-data="billFinalRowData"
          style="width:100%;height:200px"
          @gridReady="params=>{bill.gridApi=params.api}"
        />
        <div style="padding:5px 0">
          <div style="float:right">
            <el-button no="59" :disabled="readonly || !elementDict.orderBusinessAssociation.writable" type="primary" @click="pm.newSubBillHandler()">{{ $t('SeaExport.Add') }}</el-button>
            <el-button no="60" :disabled="readonly || !elementDict.orderBusinessAssociation.writable" type="danger" @click="pm.delSubBillHandler()">{{ $t('SeaExport.Delete') }}</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item v-show="job.typeVirtualHbl===VirtualBillType.MERGE_VIRTUAL_BILL_TYPE.code" slot="orderBusinessAssociation" label-width="0" class="auto-width">
        <cargo-ag-grid
          no="66"
          config-module="2023121501"
          :disabled="readonly || !elementDict.orderBusinessAssociation.writable"
          :grid-options="virtualMergeBill.gridOptions"
          :column-defs="virtualMergeBill.columnDefs"
          :row-data="virtualMergeBillFinalRowData"
          style="width:100%;height:200px"
          @gridReady="params=>{virtualMergeBill.gridApi=params.api}"
        />
        <div style="padding:5px 0">
          <div style="float:right">
            <el-button no="67" :disabled="readonly || !elementDict.orderBusinessAssociation.writable" type="primary" @click="pm.joinVirtualMergeBillHandler()">{{ $t('SeaExport.Join') }}</el-button>
            <el-button no="68" :disabled="readonly || !elementDict.orderBusinessAssociation.writable" type="danger" @click="pm.removeVirtualMergeBillHandler()">{{ $t('SeaExport.Delete') }}</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.releaseType.viewable" slot="releaseType">
        <line-label slot="label" :class="elementDict.releaseType.isRequire ? 'blue' : ''" :label="elementDict.releaseType.label" />
        <el-select
          no="61"
          :disabled="readonly || !elementDict.releaseType.writable"
          :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
          :value="form.releaseType||''"
          @input="val=>{form.releaseType=val}"
          @change="val=>{pm.cmbreleaseTypeMBLChangeHandler(val)}"
        >
          <el-option
            v-for="(item,index) in blModeList"
            :key="index"
            :label="item.name"
            :value="item.serialNumber"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.issuerBL.viewable" slot="issuerBL">
        <line-label slot="label" :class="elementDict.issuerBL.isRequire ? 'blue' : ''" :label="elementDict.issuerBL.label" />
        <cargo-advance-select
          ref="orderFormType"
          no="62"
          :disabled="readonly || !elementDict.issuerBL.writable"
          :select-type="TYPE_NAMES.basic_data_OrderFormType"
          filterable
          :default-value="form.issuerBL"
          style="width:100%;"
          @parentCallBack="p=>{pm.cmbissuerHBLChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.typeVirtualHbl.viewable" slot="typeVirtualHbl">
        <line-label slot="label" :class="elementDict.typeVirtualHbl.isRequire ? 'blue' : ''" :label="elementDict.typeVirtualHbl.label" />
        <el-select
          :value="job.typeVirtualHbl||0"
          :disabled="readonly||cmbtypeHAWB2Disabled || !elementDict.typeVirtualHbl.writable"
          no="typeVirtualHbl"
          :clearable="false"
          @input="val=>{pm.typeVirtualHblChangeHandler(val)}"
        >
          <el-option
            v-for="(item,index) in VIRTUAL_BILL_TYPES"
            :key="index"
            :label="item.chineseName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.printParam4.viewable" slot="printParam4">
        <line-label slot="label" :class="elementDict.printParam4.isRequire ? 'blue' : ''" :label="elementDict.printParam4.label" />
        <el-select v-model="form.printParam4" no="63" :disabled="readonly || !elementDict.printParam4.writable" :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')" filterable allow-create>
          <el-option
            v-for="(item,index) in pm.printParam4Type"
            :key="index"
            :label="item.label"
            :value="item.data"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.printParam5.viewable" slot="printParam5">
        <line-label slot="label" :class="elementDict.printParam5.isRequire ? 'blue' : ''" :label="elementDict.printParam5.label" />
        <el-select v-model="form.printParam5" no="64" :disabled="readonly || !elementDict.printParam5.writable" :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')">
          <el-option
            v-for="(item,index) in pm.printParam5Type"
            :key="index"
            :label="item.label"
            :value="item.data"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-show="elementDict.container.viewable && job.containerLoadType==='BB'" slot="container">
        <line-label slot="label" :class="elementDict.container.isRequire ? 'blue' : ''" :label="elementDict.container.label" />
        <cargo-rich-textarea
          v-model="form.container"
          no="65"
          :disabled="readonly || !elementDict.container.writable"
          :text-chars="0"
          wrap-symbol="r"
          style="height: 110px;"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.CNTRNOSSEALNOS'),form.container,val=>{form.container=val},true,{warningCount:45})"
        />
      </el-form-item>
      <!-- 提单确认状态 -->
      <el-form-item v-if="elementDict.lblCfrState.viewable" slot="lblCfrState" class="red">
        <line-label slot="label" :class="elementDict.lblCfrState.isRequire ? 'blue' : ''" :label="elementDict.lblCfrState.label" />
        <el-input :value="lblCfrState" :disabled="true" style="flex: 1" />
      </el-form-item>
      <!-- 提单签发状态 -->
      <el-form-item v-if="elementDict.billLadingIssued.viewable" slot="billLadingIssued" class="red">
        <line-label slot="label" :class="elementDict.billLadingIssued.isRequire ? 'blue' : ''" :label="elementDict.billLadingIssued.label" />
        <el-input :value="billLadingIssued" :disabled="true" />
      </el-form-item>
      <div v-if="elementDict.billOfLadingPackingInfo.viewable" slot="billOfLadingPackingInfo" class="section">
        <span class="title">{{ $t('SeaExport.BillOfLadingPackingInfo') }}</span>
        <div style="display:flex;flex-direction:column">
          <div v-show="isEdit" style="padding:5px 0">
            <el-button no="AddPackingInfo" type="primary" :disabled="!btnContainerEnable || !elementDict.billOfLadingPackingInfo.writable" @click="pm.addContainerUsageClickHandler()">{{ $t('SeaExport.AddPackingInfo') }}</el-button>
            <el-button no="RemovePackingInfo" type="primary" :disabled="!btnContainerEnable || !elementDict.billOfLadingPackingInfo.writable" @click="pm.removeContainerUsageClickHandler()">{{ $t('SeaExport.RemovePackingInfo') }}</el-button>
          </div>
          <cargo-ag-grid
            no="BillOfLadingPackingInfo"
            :grid-options="container.gridOptions"
            :column-defs="containerColumnDefs"
            :row-data="ediContainerFinalRowData"
            style="width:100%;height:350px"
            @gridReady="params=>{container.gridApi=params.api}"
          />
        </div>
      </div>
    </tab-sub-bill-UICustom-layout>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :disabled="readonly"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="job"
      :params="billAddressDialog.params"
      @callback="codeSearchCallback"
    />
    <!-- 工作单检索弹窗 -->
    <job-no-transcribe-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      @selected="searchBillNoDialog.selectHandler"
    />
    <!-- 抄录弹窗 -->
    <transcribe-dialog
      :visible.sync="transcribeDialog.visible"
      :job="job"
      @callback="transcribeCallback"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
      :return-main-callback="returnMainCallback"
    />
    <!-- 选择装箱信息弹窗 -->
    <add-cargo-doc-container-dialog
      :visible.sync="cargoDocUsageSelectedDialog.visible"
      :job="job"
      :doc-type="CargoDocConsts.HBL2"
      :cargo-docs="billFinalRowData"
      page-source="subBill"
      @callback="cargoDocUsageSelectedDialog.callback"
    />
  </div>
</template>

<script>
import { TabError } from '@/utils/class/TabError'
import tabSubBillUICustomLayout from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabSubBillUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabSubBill from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabSubBill'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'TabSubBillUICustom',
  components: { tabSubBillUICustomLayout },
  extends: tabSubBill,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {}
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        UICustomUtil.handleViewAndWrite(UICustomConstants.SEA_BOOKING_VIRTUAL_HBL, this.elementDict, row)
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_VIRTUAL_HBL, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    validateRequire(form) {
      for (const name in this.elementDict) {
        const element = this.elementDict[name]
        if (!(element.visible && element.writable && element.isRequire)) {
          continue
        }
        if (name === 'shipper') {
          let shipperLine = ''
          for (let i = 1; i <= 7; ++i) {
            shipperLine += form['shipperLine' + i]
          }
          if (StrUtils.isEmpty(shipperLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabSubBill')
          }
          continue
        }
        if (name === 'consignee') {
          let consigneeLine = ''
          for (let i = 1; i <= 7; ++i) {
            consigneeLine += form['consigneeLine' + i]
          }
          if (StrUtils.isEmpty(consigneeLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabSubBill')
          }
          continue
        }
        if (name === 'notify') {
          let notifyLine = ''
          for (let i = 1; i <= 7; ++i) {
            notifyLine += form['notifyLine' + i]
          }
          if (StrUtils.isEmpty(notifyLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabSubBill')
          }
          continue
        }
        if (name === 'agentParty') {
          let agentPartyLine = ''
          for (let i = 1; i <= 7; ++i) {
            agentPartyLine += form['agentPartyLine' + i]
          }
          if (StrUtils.isEmpty(agentPartyLine)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabSubBill')
          }
          continue
        }
        if (name === 'dispatchingPlaceCode') {
          if (StrUtils.isEmpty(form.dispatchingPlaceCode) || StrUtils.isEmpty(form.dispatchingPlace)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabSubBill')
          }
          continue
        }
        if (name === 'loadingPortCode') {
          if (StrUtils.isEmpty(form.loadingPortCode) || StrUtils.isEmpty(form.loadingPort)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabSubBill')
          }
          continue
        }
        if (name === 'dischargingPortCode') {
          if (StrUtils.isEmpty(form.dischargingPortCode) || StrUtils.isEmpty(form.dischargingPort)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabSubBill')
          }
          continue
        }
        if (name === 'destinationPortCode') {
          if (StrUtils.isEmpty(form.destinationPortCode) || StrUtils.isEmpty(form.destinationPort)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [element.label]), 'tabSubBill')
          }
          continue
        }
        if (element.fieldNames && element.fieldNames.length > 0) {
          for (const key of element.fieldNames) {
            const field = this.fieldDict[key]
            const label = element.fieldNames.length > 1 ? field.label : element.label
            if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabSubBill')
            }
          }
        }
      }
    }
  }
}
</script>
